import { useState, useRef, useEffect } from 'react';
import request from '@/utils/request';
import { loginUrl } from '@/service/util';

export default function useLoginCode(locale: string, form: any) {
    const [isOpenTwoFactor, setIsOpenTwoFactor] = useState(false);
    const [resendCode, setResendCode] = useState(0);
    const [sendCodeLoading, setSendCodeLoading] = useState(false);

    // 是否已经人机校验成功
    const [havedHumanMachineCheck, setHavedHumanMachineCheck] = useState(false);
    // 是否需要人机校验
    const [displayHumanMachineCheck, setDisplayHumanMachineCheck] = useState(false);

    // 记录已检查过双因子的邮箱
    const checkedEmailRef = useRef<string>('');

    // 获取是否开启双因子验证
    const getIsOpenTwoFactor = async (account: string) => {
        // /usercenter/inuc/getAccountWebsiteTwoFactorAuthConfig
        const res = await request.get(`${loginUrl(locale)}/usercenter/inuc/getAccountWebsiteTwoFactorAuthConfig`, {
            params: {
                account,
            },
        });

        if (res.code === '0') {
            setIsOpenTwoFactor(res.data);
            checkedEmailRef.current = account;
            return [true, res.data];
        } else {
            setIsOpenTwoFactor(false);
            checkedEmailRef.current = account;
            return [false, res.message];
        }
    };

    // 确保在登录前检查过双因子（用于自动填充场景）
    const ensureTwoFactorChecked = async () => {
        const email = form.getFieldValue('email')?.trim();
        if (email && email !== checkedEmailRef.current) {
            return false;
        }
        return true;
    };

    // 获取是否需要人机校验
    const getIsNeedHumanCheck = async () => {
        // /auth/humanMachineCheck/switch
        const res = await request.get(`${loginUrl(locale)}/auth/humanMachineCheck/websiteSwitch`, {
            params: {
                functionName: 'login',
                account: form.getFieldsValue()['email'] || '',
                isWebsite: true,
            },
        });

        if (res.code === '0') {
            setDisplayHumanMachineCheck(res.data);
            return [true, res.data];
        } else {
            setDisplayHumanMachineCheck(true);
            return [false, res.message];
        }
    };

    // 发送验证码
    const sendVerificationCode = async (recaptchaResponse?: string) => {
        setSendCodeLoading(true);
        try {
            const res = await request.post(`${loginUrl(locale)}/auth/verificationCode/websiteSend`, {
                data: {
                    scene: 'WEBSITE_LOGIN_VERIFICATION_CODE',
                    account: form.getFieldsValue()['email'],
                    isWebsite: true,
                    recaptchaResponse: recaptchaResponse,
                },
            });

            if (res.code === '0') {
                setResendCode(60);
            } else {
                // setIsErrorTip(true);
                // setErrorTip(res.message);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setSendCodeLoading(false);
        }
    };

    // 发送验证码前判断是否需要开启人机校验
    const handleSendVerificationCode = async (recaptchaResponse?: string) => {
        // /auth/humanMachineCheck/switch
        const [result, data] = await getIsNeedHumanCheck();

        if (!result) {
            // 接口报错， 提示错误
            return;
        } else if (!data) {
            // 不需要人机校验, 直接发送验证码
            await sendVerificationCode();
        } else {
            // 需要人机校验
            // 判断是否人机校验成功

            if (!havedHumanMachineCheck) {
                form.validateFields(['recaptchaResponse']);
                return;
            } else {
                await sendVerificationCode(recaptchaResponse);
            }
        }
    };

    useEffect(() => {
        if (isOpenTwoFactor) {
            setResendCode(0);
        }
    }, [isOpenTwoFactor]);

    return {
        isOpenTwoFactor,
        setIsOpenTwoFactor,
        resendCode,
        sendCodeLoading,
        setResendCode,
        havedHumanMachineCheck,
        displayHumanMachineCheck,
        getIsNeedHumanCheck,
        setHavedHumanMachineCheck,

        getIsOpenTwoFactor,
        ensureTwoFactorChecked,
        handleSendVerificationCode,
    };
}
